module.exports = require("pino");


//////////////////
// WEBPACK FOOTER
// external "pino"
// module id = 12
// module chunks = 0